

import {
  FETCH_SCHEDULED_BOOKINGS_REQUEST,
  FETCH_SCHEDULED_BOOKINGS_SUCCESS,
  FETCH_SCHEDULED_BOOKINGS_FAIL,
  CREATE_SCHEDULED_BOOKING_REQUEST,
  CREATE_SCHEDULED_BOOKING_SUCCESS,
  CREATE_SCHEDULED_BOOKING_FAIL,
  UPDATE_SCHEDULED_BOOKING_REQUEST,
  UPDATE_SCHEDULED_BOOKING_SUCCESS,
  UPDATE_SCHEDULED_BOOKING_FAIL,
  CANCEL_SCHEDULED_BOOKING_REQUEST,
  CANCEL_SCHEDULED_BOOKING_SUCCESS,
  CANCEL_SCHEDULED_BOOKING_FAIL,
  SET_ACTIVE_SCHEDULED_BOOKING,
  CLEAR_ACTIVE_SCHEDULED_BOOKING,
  ADD_RESOURCE_ASSIGNMENT,
  REMOVE_RESOURCE_ASSIGNMENT,
  UPDATE_RESOURCE_ASSIGNMENT,
  CLEAR_SCHEDULED_BOOKING_ERROR,
} from "../constants/ScheduledBookingConstants";

const initialState = {
  items: [],
  activeBooking: null,
  loading: false,
  error: null,
  cancellingMap: {},
};

/*
  Scheduled Booking Structure:
  {
    scheduledBookingId: "SB-2026-02-27-001",
    vehicleId: "V123",
    vehicleName: "Forklift-001",
    vehicleType: "F", // F, L, V, B, etc.
    bookedBy: "EMP001",
    bookedDate: "2026-02-27",
    startTime: "09:00",
    endTime: "10:00",
    status: "Scheduled", // Scheduled, In-Progress, Completed, Cancelled
    resources: [
      {
        resourceId: "TR123",
        type: "Trailer", // Trailer or Crane
        name: "Trailer-001",
        startTime: "09:00",
        endTime: "09:30",
      }
    ],
    notes: "",
    createdAt: timestamp,
    updatedAt: timestamp,
  }
*/

export const ScheduledBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SCHEDULED_BOOKINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SCHEDULED_BOOKINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload || [],
        error: null,
      };

    case FETCH_SCHEDULED_BOOKINGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_SCHEDULED_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_SCHEDULED_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        items: [action.payload, ...state.items],
        activeBooking: action.payload,
        error: null,
      };

    case CREATE_SCHEDULED_BOOKING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SCHEDULED_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_SCHEDULED_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map((b) =>
          b.scheduledBookingId === action.payload.scheduledBookingId
            ? action.payload
            : b
        ),
        activeBooking:
          state.activeBooking?.scheduledBookingId ===
          action.payload.scheduledBookingId
            ? action.payload
            : state.activeBooking,
        error: null,
      };

    case UPDATE_SCHEDULED_BOOKING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CANCEL_SCHEDULED_BOOKING_REQUEST:
      return {
        ...state,
        cancellingMap: {
          ...state.cancellingMap,
          [action.payload]: true,
        },
        error: null,
      };

    case CANCEL_SCHEDULED_BOOKING_SUCCESS:
      return {
        ...state,
        items: state.items.map((b) =>
          b.scheduledBookingId === action.payload
            ? { ...b, status: "Cancelled" }
            : b
        ),
        activeBooking:
          state.activeBooking?.scheduledBookingId === action.payload
            ? { ...state.activeBooking, status: "Cancelled" }
            : state.activeBooking,
        cancellingMap: {
          ...state.cancellingMap,
          [action.payload]: false,
        },
        error: null,
      };

    case CANCEL_SCHEDULED_BOOKING_FAIL:
      return {
        ...state,
        error: action.payload?.message || "Failed to cancel scheduled booking.",
        cancellingMap: {
          ...state.cancellingMap,
          [action.payload?.scheduledBookingId]: false,
        },
      };

    case SET_ACTIVE_SCHEDULED_BOOKING:
      return {
        ...state,
        activeBooking: action.payload,
      };

    case CLEAR_ACTIVE_SCHEDULED_BOOKING:
      return {
        ...state,
        activeBooking: null,
      };

    case ADD_RESOURCE_ASSIGNMENT:
      if (!state.activeBooking) return state;
      return {
        ...state,
        activeBooking: {
          ...state.activeBooking,
          resources: [...state.activeBooking.resources, action.payload],
        },
      };

    case REMOVE_RESOURCE_ASSIGNMENT:
      if (!state.activeBooking) return state;
      return {
        ...state,
        activeBooking: {
          ...state.activeBooking,
          resources: state.activeBooking.resources.filter(
            (r) => r.resourceId !== action.payload
          ),
        },
      };

    case UPDATE_RESOURCE_ASSIGNMENT:
      if (!state.activeBooking) return state;
      return {
        ...state,
        activeBooking: {
          ...state.activeBooking,
          resources: state.activeBooking.resources.map((r) =>
            r.resourceId === action.payload.resourceId ? action.payload : r
          ),
        },
      };

    case CLEAR_SCHEDULED_BOOKING_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
